/* Tag look (dev theme): colour dots for the tag pictures.
   The pictures are plain <img data-nw-look="handle"> of NW Studio's ready-made pictures, served by the nw-tag-look
   worker (…/ri/<handle>/<colour>/im.webp), put into the page by Liquid, so they load like any photo. This script adds
   the dots: NW Studio's colours for the design; a tap fades in that colour's picture. */
(function () {
  var BASE = 'https://look.northwoofs.com';
  /* "Colour: name" on the left (Colour bold, the name not), then all the dots in one row: they shrink to fit up to 9+ on a phone */
  var css = '.nwh .nw-chint.nw-look-on{flex-direction:column;align-items:stretch;align-self:stretch;width:100%;text-align:left;gap:8px}' +
    '.nw-look-l{font-size:14px;color:var(--ink,#2e2e2e);text-align:left}.nwh .nw-chint .nw-look-l b{font-weight:800}.nw-look-n{font-weight:400}' +
    '.nw-look-d{display:flex;gap:8px;flex-wrap:nowrap;justify-content:flex-start;padding:5px;margin:0 -5px}' +
    '.nw-look-d button{flex:0 1 34px;min-width:0;width:auto;height:auto;aspect-ratio:1;max-width:34px;border-radius:50%;border:0;padding:0;cursor:pointer;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);outline:2px solid transparent;outline-offset:3px}' +
    '.nw-look-d button[aria-pressed=true]{outline-color:var(--nw-ink,#2e2e2e)}.nw-look-d button:focus-visible{outline-color:var(--nw-rust,#aa4513)}' +
    '.nwh .tile .im img.nw-look-tile{padding:0;object-fit:contain}' +
    /* up to 9 colour dots on a card: they shrink to fit a narrow card instead of wrapping, filling its width exactly
       (the 8 gaps between them are the row's own gap, --sws-gap in nw-home.css) */
    /* size from the card's width (container units), the same number for width and height, so iPhone Safari keeps them
       round (it stretched buttons sized by aspect-ratio into ovals) */
    '.nwh .sws.sws--many{flex-wrap:nowrap;min-width:0;container-type:inline-size}' +
    '.nwh .sws.sws--many .sw{--d:min(26px,calc((100cqw - 8 * var(--sws-gap,4px)) / 9));flex:0 0 var(--d);width:var(--d);height:var(--d);min-width:0;padding:2px}' +
    '.nw-look-s{display:flex;gap:8px;flex-wrap:wrap;padding:5px;margin:0 -5px}' +
    '.nw-look-s button{width:34px;height:34px;border-radius:50%;border:0;padding:0;cursor:pointer;overflow:hidden;background:#f3f1ee;box-shadow:inset 0 0 0 1px rgba(0,0,0,.08);outline:2px solid transparent;outline-offset:3px}' +
    '.nw-look-s button img{display:block;width:100%;height:100%}' +
    '.nw-look-s button[aria-pressed=true]{outline-color:var(--nw-ink,#2e2e2e)}.nw-look-s button:focus-visible{outline-color:var(--nw-rust,#aa4513)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var imgs = [].slice.call(document.querySelectorAll('img[data-nw-look]'));
  if (!imgs.length) return;
  var handles = [];
  imgs.forEach(function (i) { if (handles.indexOf(i.dataset.nwLook) < 0) handles.push(i.dataset.nwLook); });
  var slug = function (v) { return String(v).toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  /* pictures are addressed by colour name, the same address the page itself uses for ?colour=, so nothing loads twice */
  /* ?d= picks one of a design's other looks (Canicross Woman); the default look carries none */
  var lookD = null;
  /* a picture may show a local copy (live colours, below); its worker address stays in data-nw-src */
  var logical = function (img) { return img.dataset.nwSrc || img.src; };
  /* the colour a picture starts on: the one in its address (Liquid puts the product's default colour there,
     metafield northwoofs.default_colour), by name or number; the first colour otherwise */
  var startOf = function (img, pals) {
    var m = /\/ri\/[\w-]+\/([\w-]+)\//.exec(logical(img)), c = m ? m[1] : '0', i = 0;
    if (/^\d+$/.test(c)) return Math.min(pals.length - 1, Number(c));
    pals.forEach(function (p, k) { if (slug(p.label) === c) i = k; });
    return i;
  };
  var srcFor = function (img, label) {
    var s = logical(img).replace(/\/ri\/([\w-]+)\/[\w-]+\/(\w+)\.webp/, '/ri/$1/' + slug(label) + '/$2.webp');
    try { var u = new URL(s); if (lookD) u.searchParams.set('d', lookD); else u.searchParams.delete('d'); s = u.toString(); } catch (e) {}
    return s;
  };
  /* NW Studio's ready-made pictures: a colour is a picture of its own. The new one is decoded first, then a copy of
     it is laid over the old one in the same box and faded in. The page's own picture changes underneath only while it
     is covered, and the copy is taken away only after that picture shows the new colour: iPhones blank an <img> for a
     frame when its address changes, which showed the white card for a moment. */
  var warm = function (url) { var w = new Image(); w.src = url; return w; };
  var dec = function (im) { return (im.decode ? im.decode() : new Promise(function (r) { if (im.complete) r(); else im.onload = r; })).catch(function () {}); };
  var frames = function (n) { return new Promise(function (r) { (function f() { if (n-- <= 0) r(); else requestAnimationFrame(f); })(); }); };
  var show = function (img, url, pals, label, fade) {
    img.dataset.nwSrc = url;
    var tok = img._nwTok = (img._nwTok || 0) + 1;
    dec(warm(url)).then(function () {
      if (img._nwTok !== tok) return;   /* another colour was tapped meanwhile */
      if (!img.offsetParent || !img.offsetWidth || !img.getAttribute('src')) { img.src = url; return; }
      var top = img._nwTop;
      if (!top) {
        top = img._nwTop = img.cloneNode(false);
        ['data-nw-look', 'id', 'loading', 'onerror', 'srcset', 'sizes'].forEach(function (a) { top.removeAttribute(a); });
        top.alt = ''; top.setAttribute('aria-hidden', 'true');
      }
      if (top.getAnimations) top.getAnimations().forEach(function (a) { a.cancel(); });
      top.style.cssText = 'position:absolute;margin:0;pointer-events:none;z-index:1;left:' + img.offsetLeft + 'px;top:' + img.offsetTop + 'px;width:' + img.offsetWidth + 'px;height:' + img.offsetHeight + 'px;opacity:0';
      top.src = url;
      if (top.previousElementSibling !== img) img.after(top);
      dec(top).then(function () {
        if (img._nwTok !== tok) return;
        var anim = fade && Element.prototype.animate ? top.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out', fill: 'forwards' }).finished : Promise.resolve();
        if (!fade) top.style.opacity = '1';
        return anim.then(function () {
          if (img._nwTok !== tok) return;
          img.src = url;
          return dec(img).then(function () { return frames(3); }).then(function () {
            if (img._nwTok !== tok) return;
            top.getAnimations && top.getAnimations().forEach(function (a) { a.cancel(); });
            top.remove();
          });
        });
      });
    });
    return url;
  };
  var setAll = function (list, label, pals, glide) {
    var first = null;
    /* a tap on a dot: every copy glides (the big picture only when it is the one in view; the thumbnails always) */
    list.forEach(function (img, k) { var u = show(img, srcFor(img, label), pals, label, glide === undefined ? false : (k === 0 ? glide : true)); if (!k) first = u; });
    /* the photo viewer, once opened, keeps its own copy of the first picture */
    var s0 = document.querySelector('.nw-lb__rail .nw-lb__slide img'), t0 = document.querySelector('.nw-lb__th button img');
    if (first && list[0].closest('[data-nwp-gal]')) { if (s0) { s0.dataset.src = first; if (s0.getAttribute('src')) s0.src = first; } if (t0) t0.src = first; }
  };

  fetch(BASE + '/pals?h=' + encodeURIComponent(handles.slice(0, 60).join(',')), { cache: 'no-cache' })   /* colours and looks straight after a change in NW Studio */.then(function (r) { return r.json(); }).then(function (pals) {
    /* product page */
    var gal = document.querySelector('[data-nwp-gal]');
    var mine = imgs.filter(function (i) { return gal && (gal.contains(i) || i.closest('[data-nwp-thumbs]')); });
    var ph = mine[0] && mine[0].dataset.nwLook, P = ph && pals[ph];
    /* no drawn colours for this product: give its Colour buttons back */
    var S = ph && pals[ph + '~styles'];   // {row, items:[{label, d, thumb}]} for a design with several looks
    if (!(P && P.length > 1)) [].forEach.call(document.querySelectorAll('[data-by-look]'), function (f) { f.hidden = false; });
    else if (!S) [].forEach.call(document.querySelectorAll('[data-by-look]:not([data-name="colour"]):not([data-name="color"])'), function (f) { f.hidden = false; });
    if (P && P.length) {
      var cur = 0, want = null;
      try { want = new URLSearchParams(location.search).get('colour'); } catch (e) {}
      /* a tag sold as colour variants (Aztec, Lunar): the hidden Colour buttons follow the dots, and a ?variant= link opens on its colour */
      var vopt = document.querySelector('[data-by-look][data-name="colour"],[data-by-look][data-name="color"]') || document.querySelector('[data-by-look]');
      var sopt = S && document.querySelector('[data-by-look][data-name="' + String(S.row || '').toLowerCase() + '"]');
      var sc = 0;
      if (S) {
        var sp = sopt && sopt.querySelector('button[aria-pressed="true"]');
        if (sp) S.items.forEach(function (it, i) { if (it.label.toLowerCase() === sp.dataset.v.toLowerCase()) sc = i; });
        lookD = S.items[sc].d;
        window.__nwLookStyle = S.items[sc].label;
      }
      var pickStyle = function (label) {
        var c = sopt && [].filter.call(sopt.querySelectorAll('button[data-v]'), function (b) { return b.dataset.v.toLowerCase() === String(label).toLowerCase(); })[0];
        if (c && c.getAttribute('aria-pressed') !== 'true') c.click();
      };
      var chipFor = function (label) { return vopt && [].filter.call(vopt.querySelectorAll('button[data-v]'), function (b) { return b.dataset.v.toLowerCase() === String(label).toLowerCase(); })[0]; };
      var pressed = vopt && vopt.querySelector('button[aria-pressed="true"]');
      if (!want && pressed && /[?&]variant=/.test(location.search)) want = pressed.dataset.v;
      if (mine[0] && !want) cur = startOf(mine[0], P);
      P.forEach(function (p, i) { if (want && p.label.toLowerCase() === want.toLowerCase()) cur = i; });
      /* the address carries the colour, so a reload draws it straight away: ?variant= on colour-variant tags (set by
         the variant buttons), ?colour= on the others (read by the nw-look-colour snippet before the picture shows) */
      var setColourParam = function (label) {
        if (vopt || P.length < 2) return;   /* one colourway: nothing to remember */
        try { var u = new URL(location.href); if (u.searchParams.get('colour') === label) return; u.searchParams.set('colour', label); history.replaceState(history.state, '', u); } catch (e) {}
      };
      var pickVariant = function (label) { setColourParam(label); var c = chipFor(label); if (c && c.getAttribute('aria-pressed') !== 'true') c.click(); };
      if (cur) pickVariant(P[cur].label);
      /* closing the personalizer steps back in history, to the address from before it opened; keep the colour picked since */
      window.addEventListener('popstate', function () {
        setTimeout(function () {
          if (!vopt) { if (P[cur]) setColourParam(P[cur].label); return; }
          var inp = document.querySelector('form[data-nwp-form] input[name="id"]'); if (!inp || !inp.value) return;
          try { var u = new URL(location.href); if (u.searchParams.get('variant') === inp.value) return; u.searchParams.set('variant', inp.value); history.replaceState(history.state, '', u); } catch (e) {}
        }, 0);
      });
      if (cur) setAll(mine, P[cur].label, P);
      mine.forEach(function (img) { img.dataset.nwPi = cur; });
      /* the other colours' pictures, a moment after the page has settled, so a tap on a dot is instant */
      if (mine[0]) setTimeout(function () { P.forEach(function (p, i) { if (i !== cur) warm(srcFor(mine[0], p.label)); }); }, 1500);
      var hint = document.querySelector('.nw-chint--dots');
      if (hint && P.length > 1) {
        hint.classList.add('nw-look-on'); hint.hidden = false;
        var colour = window.NWT.collection.colour;
        hint.innerHTML = '<span class="nw-look-l"><b>' + colour + ':</b> <span class="nw-look-n"></span></span><span class="nw-look-d" role="group" aria-label="' + colour + '"></span>' +
          (S ? '<span class="nw-look-l"><b>' + S.row + ':</b> <span class="nw-look-sn"></span></span><span class="nw-look-s" role="group" aria-label="' + S.row + '"></span>' : '');
        var name = hint.querySelector('.nw-look-n'), row = hint.querySelector('.nw-look-d');
        var sync = function () { window.__nwLookColour = P[cur].label; name.textContent = P[cur].label; [].forEach.call(row.children, function (b, i) { b.setAttribute('aria-pressed', i === cur); }); };
        P.forEach(function (p, i) {
          var b = document.createElement('button'); b.type = 'button'; b.style.background = p.swatch; b.title = p.label; b.setAttribute('aria-label', p.label);
          b.addEventListener('click', function () {
            cur = i; sync(); setAll(mine, p.label, P, !gal.scrollLeft); pickVariant(p.label);
            try { sessionStorage.setItem('nw-look:' + ph, p.label); } catch (e) {}
            window.dispatchEvent(new CustomEvent('nw:look-colour', { detail: { label: p.label, handle: ph } }));
            if (gal.scrollLeft) gal.scrollTo({ left: 0, behavior: 'smooth' });
          });
          row.appendChild(b);
        });
        sync();
        /* a design with several looks (Canicross: Man / Woman runner): a row of small pictures under the colours */
        if (S) {
          var sname = hint.querySelector('.nw-look-sn'), srow = hint.querySelector('.nw-look-s');
          var ssync = function () { window.__nwLookStyle = S.items[sc].label; sname.textContent = S.items[sc].label; [].forEach.call(srow.children, function (b, i) { b.setAttribute('aria-pressed', i === sc); }); };
          var setStyle = function (i, tell) {
            if (i === sc) return;
            sc = i; lookD = S.items[sc].d; ssync(); setAll(mine, P[cur].label, P); pickStyle(S.items[sc].label);
            if (tell) window.dispatchEvent(new CustomEvent('nw:look-style', { detail: { label: S.items[sc].label, handle: ph } }));
          };
          S.items.forEach(function (it, i) {
            var b = document.createElement('button'); b.type = 'button'; b.title = it.label; b.setAttribute('aria-label', it.label);
            b.innerHTML = '<img src="' + it.thumb + '" alt="" width="34" height="34">';
            b.addEventListener('click', function () { setStyle(i, true); if (gal.scrollLeft) gal.scrollTo({ left: 0, behavior: 'smooth' }); });
            srow.appendChild(b);
          });
          ssync();
          window.dispatchEvent(new CustomEvent('nw:look-style', { detail: { label: S.items[sc].label, handle: ph } }));
          window.addEventListener('nw:pz-style', function (e) {
            var lc = String(e.detail && e.detail.label || '').toLowerCase();
            S.items.forEach(function (it, i) { if (it.label.toLowerCase() === lc) setStyle(i, false); });
          });
        }
        /* tell the personalizer too, in case it loaded before this */
        window.dispatchEvent(new CustomEvent('nw:look-colour', { detail: { label: P[cur].label, handle: ph } }));
        /* the personalizer changed the colour: the page's picture, dots and variant follow */
        window.addEventListener('nw:pz-colour', function (e) {
          var lc = String(e.detail && e.detail.label || '').toLowerCase(), j = -1;
          P.forEach(function (p, i) { if (p.label.toLowerCase() === lc) j = i; });
          if (j < 0 || j === cur) return;
          cur = j; sync(); setAll(mine, P[j].label, P); pickVariant(P[j].label);
          try { sessionStorage.setItem('nw-look:' + ph, P[j].label); } catch (e2) {}
        });
      }
    }
    /* tiles: their dots become NW Studio's colours */
    [].forEach.call(document.querySelectorAll('a.tile'), function (a) {
      var img = a.querySelector('img[data-nw-look]'); if (!img) return;
      var T = pals[img.dataset.nwLook]; if (!T || !T.length) return;
      var sws = a.querySelector('.sws'); if (!sws) return;
      sws.querySelectorAll('.sw,.sw-more').forEach(function (x) { x.remove(); });
      if (T.length < 2) return;   /* one colourway (Woodgrain, Vanlife, Roastscape, Northern Lights): no dots */
      sws.classList.toggle('sws--many', T.length > 5);
      var t0 = startOf(img, T);
      T.slice(0, 9).forEach(function (p, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sw' + (i === t0 ? ' on' : ''); b.title = p.label; b.setAttribute('aria-label', p.label);
        b.innerHTML = '<i style="background:' + p.swatch + '"></i>';
        b._nwLook = function () {
          show(img, srcFor(img, p.label), T, p.label, true);
          var u = new URL(a.href, location.href); u.searchParams.set('colour', p.label); a.href = u.pathname + u.search;
        };
        sws.appendChild(b);
      });
      /* a finger on the dots loads that tile's other colours, so the tap (and the product page after it) is instant */
      var warmed = false;
      img.dataset.nwPi = t0;
      sws.addEventListener('pointerdown', function () { if (warmed) return; warmed = true; T.slice(0, 9).forEach(function (p) { warm(srcFor(img, p.label)); }); }, { passive: true });
    });
  }).catch(function () {});
  /* nw-home.js stops tile-swatch clicks on the way down (so the tile link isn't followed); catch them one step earlier */
  window.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.sw'); if (b && b._nwLook) b._nwLook(); }, true);
})();
